module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjciIGN5PSI3IiByPSI2LjUiIHN0cm9rZT0iIzcyNzI3MiIvPgogICAgPGNpcmNsZSBjeD0iNyIgY3k9IjQiIHI9IjEiIGZpbGw9IiM3MjcyNzIiLz4KICAgIDxyZWN0IHg9IjcuNzUiIHk9IjYuNSIgd2lkdGg9IjUiIGhlaWdodD0iMS41IiByeD0iMC43NSIgdHJhbnNmb3JtPSJyb3RhdGUoOTAgNy43NSA2LjUpIiBmaWxsPSIjNzI3MjcyIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/v2/server-information.svg
// module id = vKYG
// module chunks = 0